import { Box, Button } from '@mui/material';
import React from 'react';
import Text from '../../shared/Text';
import { toggleButton } from '../utils/redict-url';
import WarningIcon from './logo-icon/WarningIcon';
import { CenteredErrorMessage } from './shared-form-components';

const SsoAuthLoginIncorrectTryAgain: React.FC = () => {
  React.useEffect(() => {
    document.title = Text.get('sso_doc_title_error');
    toggleButton();
  }, []);

  return (
    <div>
      <CenteredErrorMessage
        icon={WarningIcon}
        errorMessages={['ssoAuthSignIn_incorrect_message1', 'ssoAuthSignIn_incorrect_message2_alt']}
      >
        <Box mt={2.5}>
          <Button id="try-again-btn" variant="contained" onClick={toggleButton}>
            {Text.get('ssoAuthSignIn_try_again')}
          </Button>
        </Box>
      </CenteredErrorMessage>
    </div>
  );
};

export default SsoAuthLoginIncorrectTryAgain;
